import i18n from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import dayjs from 'dayjs'

import _find from 'lodash/find'

import enUS from 'antd/lib/locale/en_US'
import thTH from 'antd/lib/locale/th_TH'

import enCommon from './en/common'
import thCommon from './th/common'

export const defaultLanguage = 'th'

export const languages = [
  {
    key: 'en',
    dayjsKey: 'en',
    translation: enCommon,
    name: 'EN',
    antdLocale: enUS,
  },
  {
    key: 'th',
    dayjsKey: 'th',
    translation: thCommon,
    name: 'TH',
    antdLocale: thTH,
  },
]

export const languageCodes = languages.map(language => language.key)

const resources = languages.reduce((result, value) => {
  return {
    ...result,
    [value.key]: {
      translation: value.translation,
    },
  }
}, {})

const changeLanguage = key => {
  const languageObj = _find(languages, { key })
  dayjs.locale(languageObj.dayjsKey)
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    supportedLngs: ['en', 'th'],
  })
  .then(() => {
    changeLanguage(i18n.language)
  })

i18n.on('languageChanged', function (lng) {
  changeLanguage(lng)
})

export default i18n
